<template>
  <gg-card>
    <gg-card-header>
      Access My Data Records
    </gg-card-header>
    <gg-card-text>
      <h4>Your Personal Profile</h4>
      <p>Get access to your personal information in a machine readable format.</p>
      <gg-btn secondary elevation="0" :loading="loading" class="ml-0" @click="confirmationModal = true">
        Access My Records
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
    </gg-card-text>
    <gg-modal :is-active="confirmationModal" max-width="350" @close="confirmationModal = false">
      <template #toolbar>
        Request My Data Records
      </template>
      <template #body>
        <gg-card-text>
          Please confirm you wish to request your data. This process may take up to 24 hours.
        </gg-card-text>
      </template>
      <template #actions>
        <gg-btn secondary @click="confirmationModal = false">Cancel</gg-btn>
        <gg-btn :loading="loading" @click="accessMyRecords">Confirm</gg-btn>
      </template>
    </gg-modal>
  </gg-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AccessToRecords',
  data: () => ({
    loading: false,
    confirmationModal: false
  }),
  methods: {
    ...mapActions(['accessRecords', 'gdprDataRequests', 'reportSuccess', 'reportError']),
    async accessMyRecords () {
      try {
        this.loading = true
        await this.accessRecords()
        await this.gdprDataRequests()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.confirmationModal = false
        this.loading = false
      }
    }
  }
}
</script>
